// extracted by mini-css-extract-plugin
module.exports = {"tabContent":"addlv_tabContent__1R-Sw","container":"addlv_container__381gQ","headerCancel":"addlv_headerCancel__JRWYx","body":"addlv_body__2ZujF","buttons":"addlv_buttons__x2pQO"};